export const setCompAllEventAction = status => ({
  type: 'SET_COMP_ALL_EVENT',
  payload: status,
});
